import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
@Component({
  selector: 'app-maps-coverage',
  templateUrl: './maps-coverage.component.html',
  styleUrls: ['./maps-coverage.component.scss'],
})
export class MapsCoverageComponent implements OnInit {

    constructor(public LANG: CommonUtilitiesService) {}

  ngOnInit() {
    
  }
}
